<template>
  <div :style="summaryBottom" class="spl-parcel-list-summary hide-on-mobile">
    <div class="spl-parcel-list-summary__intro">
      Parcel summary
      <div class="spl-parcel-list-summary__intro__selected">
        {{ rowsSelected }} selected
      </div>
    </div>
    <div
      v-for="(summaryItem, index) in summaryItems"
      :key="'parcelListSummary' + index"
      class="spl-parcel-list-summary__col">
      <div class="spl-parcel-list-summary__col__label">
        {{ summaryItem.label }}
      </div>
      <div :class="[{'spl-parcel-list-summary__col__value-zero': summaryItem.value === 0}, 'spl-parcel-list-summary__' + summaryItem.key]" class="spl-parcel-list-summary__col__value">
        {{ summaryItem.value }}
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers.vue'
import constants from '@/constants'

export default {
  name: 'ParcelListTableSummary',
  mixins: [Helpers],
  props: [
    'rowsSelected',
    'summaryItems'
  ],
  computed: {
    summaryBottom () {
      if (this.userHasActionBarPermissions()) {
        // Parcel list summary is shown above the action bar
        return 'bottom: ' + constants.PARCEL_LIST_SUMMARY_HEIGHT.toString() + 'px;'
      } else {
        return 'bottom: 0px;'
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-list-summary {
        background-color: $parcelListSummaryBackgroundColor;
        height: 70px;
        padding: 12px $mainPadding;
        position: fixed;
        width: 100%;

        &__intro {
            color: $parcelListSummaryIntroColor;
            display: inline-block;
            font-weight: 600;
            vertical-align: top;
            width: 185px;

            &__selected {
                color: $parcelListSummaryIntroSelectedColor;
            }
        }
        &__col {
            display: inline-block;
            margin-right: 30px;
            padding-top: 7px;
            vertical-align: top;

            &__label {
                color: $parcelListSummaryLabelColor;
                font-family: $mono;
                font-size: 9px;
                font-weight: 700;
                line-height: 12px;
                letter-spacing: 1px;
                margin-bottom: 5px;
                text-transform: uppercase;
            }
            &__value {
                color: $parcelListSummaryValueColor;
                font-size: 12px;
                font-weight: 600;

                &-zero {
                    color: $parcelListSummaryLabelColor;
                }
            }
        }
    }
</style>
